export const InvoiceSectionData = ( order_no, order_completed_on, total_items, pending_amount,action, productDetails) =>{
    return {
      order_no,
      order_completed_on,
      total_items,
      pending_amount,
      action,
      productDetails
    };
  }